export default __webpack_public_path__ + "static/media/logo-spores-primary.9fc95f72.svg";